import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
// import CookieConsent from 'react-cookie-consent'; /* temporary banner will be live from April 21 - May 5 at noon */

import { IntlContext } from '../../Providers/Intl';
import Blade from '../Blade';
import { Context } from '../../Providers/Blade';
import SkipToContent from '../SkipToContent';
import MenuItem from '../MenuItem';

import { MobileNav, DesktopNav, InfoBar } from './layout';
import {
  StyledHeader,
  Wrapper,
  LogoLink,
  Logo,
  Menu,
  Play,
  Overlay,
  StyledPromo,
} from './styles';

export const Header = ({ data, location, navHeader }) => {
  if (!data) return null;

  // * We keep the state for the header menu contained within contentxt
  const { state, resetState } = useContext(Context);

  // * Destructuring the fields off of data
  const {
    image: logo,
    imageSharp: logoSharp,
    menu,
    loginLink,
    loginText,
    playLink,
    playText,
    infobarShowHide,
    infobarBackgroundColor,
    infobarForegroundColor,
    infobarTextHtml,
    infobarCtaText,
    infobarCtaUrl,
  } = data;

  const navCtaArray = navHeader.filter(header => {
    if (location && location.pathname.includes(header.headerNavCtaUrl)) {
      return location.pathname.includes(header.headerNavCtaUrl);
    }
    return undefined;
  });

  const navCta = navCtaArray[0];

  const [openSections, setOpenSections] = useState({});

  // * We use the double ! because if the label doesnt exist in state it will return undefined, and by using the double ! we can convert the undefined to false
  const onClick = label => {
    const isOpen = !!openSections[label];
    setOpenSections({
      [label]: !isOpen,
    });
  };

  return (
    <>
      <Overlay
        isOpen={Object.values(openSections).includes(true)}
        onClick={() => setOpenSections({})}
      />
      <StyledHeader>
        <SkipToContent />
        {infobarShowHide && (
          <InfoBar
            background={infobarBackgroundColor}
            foreground={infobarForegroundColor}
            textHtml={infobarTextHtml}
            ctaText={infobarCtaText}
            ctaUrl={infobarCtaUrl.url}
          />
        )}
        <Wrapper className="auto-margin">
          <LogoLink
            className="inline"
            to="/"
            name="prodigy"
            ariaLabel="go to Prodigy homepage"
          >
            <Logo src={logoSharp.publicURL} alt={logo.altTag} />
          </LogoLink>
          <DesktopNav
            menu={menu}
            openSections={openSections}
            location={location}
            onClick={onClick}
            loginLink={loginLink}
            loginText={loginText}
            playLink={playLink}
            playText={playText}
            resetState={() => setOpenSections({})}
            navCta={navCta}
          />
          <MobileNav
            loginLink={loginLink}
            loginText={loginText}
            location={location}
            navCta={navCta}
          />
        </Wrapper>
        <Blade
          title="test-blade"
          isOpen={state}
          logo={logo}
          logoSharp={logoSharp}
        >
          <>
            {menu && (
              <Menu className="no-bullets">
                {menu.map((info, index) => {
                  return (
                    <li key={`menu-item-${index.toString()}`}>
                      <MenuItem
                        data={info}
                        isOpen={!!openSections[info.text]}
                        label={info.text}
                        onClick={onClick}
                        resetState={() => resetState()}
                        font="Work Sans"
                      />
                    </li>
                  );
                })}
              </Menu>
            )}
            {!navCta && (
              <StyledPromo
                to={loginLink.url}
                className="ghost-on-light-bg"
                ariaLabel={loginLink.ariaLabelLogin}
                queryString={loginLink.queryStringLogin}
              >
                {loginText}
              </StyledPromo>
            )}
            {navCta && navCta.headerNavCtaUrl !== undefined ? (
              <Play
                to={navCta.headerNavCtaLink.url}
                ariaLabel={playLink.ariaLabelPlay}
                queryString={playLink.queryStringPlay}
                className={navCta.headerNavCtaButtonStyle}
                font="Work Sans"
              >
                {navCta.headerNavCtaButtonText}
              </Play>
            ) : (
              <Play
                to={playLink.url}
                className="solid-on-light-bg"
                ariaLabel={playLink.ariaLabelPlay}
                queryString={playLink.queryStringPlay}
                font="Work Sans"
              >
                {playText}
              </Play>
            )}
          </>
        </Blade>
      </StyledHeader>
      {/* temporary banner this will be live from April 21 - May 5 at noon */}
      {/* <CookieConsent
        expires={14}
        style={{
          background: '#a9e7f5',
          color: '#000',
          textAlign: 'center',
          position: 'inherit',
        }}
        buttonStyle={{ background: '#a9e7f5', fontSize: '16px' }}
        buttonText="x"
        hideOnAccept="true"
        location="top"
      >
        Hi! We’ve updated our privacy policy
        <a
          style={{ display: 'inline-flex', marginLeft: '20px' }}
          href="https://https://www.prodigygame.com/main-en/privacy-policy/"
        >
          <div style={{ background: '#FFFFFF', width: 'fit-content' }}>
            <p
              style={{
                color: '#FF5C0B',
                margin: '0 15px',
                fontWeight: '600',
                borderRadius: '4px',
                borderWidth: '3px',
              }}
            >
              Read full policy
            </p>
          </div>
        </a>
      </CookieConsent> */}
    </>
  );
};

Header.propTypes = {
  data: PropTypes.shape().isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  navHeader: PropTypes.shape().isRequired,
};

Header.defaultProps = {};

const withStaticQueryHeader = ({ location }) => {
  return (
    <StaticQuery
      query={graphql`
        query headerQuery {
          prodigy {
            englishNav: headerNavCtaMappings(locale: "en-ca") {
              headerNavCtaButtonStyle
              headerNavCtaButtonText
              headerNavCtaUrl
              headerNavCtaLink {
                url
              }
            }
            indianNav: headerNavCtaMappings(locale: "en-in") {
              headerNavCtaButtonStyle
              headerNavCtaButtonText
              headerNavCtaUrl
              headerNavCtaLink {
                url
              }
            }
            headerFooter {
              header {
                lang
                image {
                  url
                  altTag
                }
                imageSharp {
                  publicURL
                }
                loginText
                loginLink {
                  url
                }
                playText
                playLink {
                  url
                }
                menu {
                  text
                  type
                  url
                  subitems {
                    text
                    type
                    url
                    subitems {
                      text
                      type
                      url
                      linkType
                      queryString
                      ariaLabel
                    }
                    queryString
                    ariaLabel
                  }
                  ariaLabel
                  queryString
                }
                queryStringPlay
                queryStringLogin
                ariaLabelPlay
                ariaLabelLogin
                infobarShowHide
                infobarBackgroundColor
                infobarForegroundColor
                infobarTextHtml
                infobarCtaText
                infobarCtaUrl {
                  url
                }
              }
            }
          }
        }
      `}
      render={({ prodigy }) => {
        const { intl } = useContext(IntlContext);
        const { header } = prodigy.headerFooter.find(
          ({ header: headerData }) =>
            headerData.lang ===
            /* check if lang being defaulted to is x-default (a catchall to default to main-en) */
            (intl.lang === 'x-default' ? 'en-ca' : intl.lang)
        );
        const navHeader =
          intl.lang === 'x-default' || intl.lang === 'en-ca'
            ? prodigy.englishNav
            : prodigy.indianNav;
        return (
          <Header data={header} location={location} navHeader={navHeader} />
        );
      }}
    />
  );
};

export default withStaticQueryHeader;
